<template>
  <div class="signUp">
    <div class="common_content">
      <el-card class="box-card">
        <div slot="header">
          <h3>{{ surePay ? '' : '测试报名' }}</h3>
        </div>
        <table class="signUp_content">
          <thead class="signUp_title">
          <tr align="center">
            <th>测试信息</th>
            <th>金额</th>
            <th v-if="surePay">实付</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="td1">
              <div class="testIndex-content">
                <div class="testIndex-left">
                  <!-- <el-image
                    style="width: 150px; height: 150px;margin-top: 10px;"
                    :src="imgPath+data.file_path"
                  ></el-image> -->
                  <img :src="imgPath+data.file_path" alt="" style="width: 150px; height: 150px;margin-top: 10px;">
                </div>
                <div class="testIndex_right">
                  <ul class="card_content_ul">
                    <li>
                      <h4>{{ data.mechanism_fullName }}</h4>
                    </li>
                    <li
                        class="card_content_li"
                    >报名时间： {{ data.registration_start_time|dateformat('YYYY-MM-DD HH:mm') }} 至
                      {{ data.registration_end_time|dateformat('YYYY-MM-DD HH:mm') }}
                    </li>
                    <li
                        class="card_content_li"
                    >测试时间：{{ data.test_start_time|dateformat('YYYY-MM-DD HH:mm') }} 至
                      {{ data.test_end_time|dateformat('YYYY-MM-DD HH:mm') }}
                    </li>
                    <li class="card_content_li">
                      测试地址：{{ data.province + data.city + data.district + data.test_detail_addr }}
                    </li>
                    <li class="card_content_li">
                      测试等级：
                      <span>{{ data.grade|grade }}</span>
                    </li>
                    <li class="card_content_li">
                      联系人：
                      <span>{{ data.contact }}</span>
                    </li>
                    <li class="card_content_li">
                      电话：
                      <span>{{ data.contact_number }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </td>
            <td :style="surePay?'border-right: 1px solid #c4c4c4;':''">
              <div class="signUp_money">
                  <span
                      :style="surePay?'color: #000000;':'color: #ea3553;'"
                  >￥{{ data.registration_fee }}</span>
              </div>
            </td>
            <td v-if="surePay">
              <div class="signUp_money">
                <span style="color: #ea3553;">￥{{ data.registration_fee }}</span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </el-card>
      <el-card class="box-card signUp_card">
        <span>合计：</span>
        <span style="color:#ea3553;">￥{{ data.registration_fee }}</span>
        <el-button
            type="danger"
            style="width:100px;height:40px"
            @click="Settlement"
            :loading="loading"
        >去报名
        </el-button>
      </el-card>
    </div>
    <p class="common_text_line common_content"></p>
  </div>
</template>

<script>
import {TestApplicationList, TestClassSignUp} from "@/api/admin/athletes.js";
import {GetDicData} from "@/api/admin/common.js";
import {mapGetters} from "vuex";
import {nowInDateBetwen, set, dateFormats} from "@/util/data.js";

let that;
export default {
  computed: {
    ...mapGetters(["userRole", "levels"])
  },
  data() {
    return {
      data: {},
      surePay: true,
      newId: {},
      imgPath: window.apiObj.apiUrl,
      test_class_can_apply_for_grade: [],
      errorMsg: "",
      gradeList: [],
      loading: false
    };
  },
  created() {
    this.path();
    GetDicData({classCode: "test_class_can_apply_for_grade"}).then(data => {
      if (data.data.result) {
        this.test_class_can_apply_for_grade = data.data.result;
      }
    });
  },
  mounted() {
    this.getList();
  },
  beforeCreate: function () {
    that = this;
  },
  methods: {
    path() {
      var pathList = [
        {title: "您当前的位置"},
        {title: "首页", path: "/index"},
        {path: "/test", title: "测试报名"},
        {
          path: this.$route.fullPath,
          title: "报名信息"
        }
      ];
      setTimeout(() => {
        this.$store.commit("SET_ROUTELIST", pathList);
      });
    },
    getList() {
      this.newId = this.$route.query;

      TestApplicationList({
        test_class_id: this.newId.id,
        grade: this.newId.key
      }).then(data => {
        const list = data.data.result;
        if (list) {
          this.data = data.data.result.items[0];

          this.isSuccess = list.isSuccess;
          this.errorMsg = list.errorMsg;
        }
      });
    },
    Settlement() {

      // this.$router.push({
      //   path: "/test/sureOrder",
      //   query: { id: this.newId.id, key: this.newId.key }
      // });
      var timeStatus = nowInDateBetwen(
          this.getDate(new Date(this.data.registration_start_time)),
          this.getDate(new Date(this.data.registration_end_time)),
          this.getDate(new Date())
      );
      if (timeStatus) {
        this.gradeList = set([this.data.grade], this.levels);
        if (this.gradeList.length > 0) {
          this.$router.push({
            path: "/test/sureOrder",
            query: {id: this.newId.id, key: this.newId.key}
          });
        } else {
          this.$message({
            message: "您未取得测试等级资格",
            type: "warning"
          });
        }
      } else {
        this.$message({
          message: "不在当前报名时间范围内",
          type: "warning"
        });
      }
    },
    getDate(date) {
      var date1 = dateFormats(date);
      return date1;
    }
  },
  filters: {
    grade: data => {
      for (var i in that.test_class_can_apply_for_grade) {
        if (that.test_class_can_apply_for_grade[i].value == data) {
          return that.test_class_can_apply_for_grade[i].label;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.signUp {
  .signUp_title {
    background-color: #f5f6f6;

    th {
      padding: 10px;
    }
  }

  .signUp_content {
    width: 100%;
    border-collapse: collapse;

    .td1 {
      width: 60%;
    }

    .testIndex-content {
      display: flex;
      border-right: 1px solid #c4c4c4;

      .testIndex_right {
        padding: 10px;

        .card_content_ul {
          position: relative;

          .card_content_li {
            margin: 5px 0px;

            .icon {
              display: inline-block;
              width: 20px;
              height: 20px;
              position: relative;
              top: 4px;
            }
          }

          .card_details {
            position: absolute;
            right: 0px;
            top: 0px;
          }

          .el-button:focus,
          .el-button:hover {
            background: #fddfe5;
            border-color: #fddfe5;
            color: #fff;
          }
        }
      }
    }

    @media screen and (max-width: 767px) {
      .testIndex-content {
        flex-direction: column;
        align-items: center;
      }
    }

    .signUp_money {
      text-align: center;
    }
  }

  .signUp_card {
    margin-top: 10px;
    text-align: right;

    span {
      display: inline-block;
      margin-right: 10px;
      font-size: 16px;
    }

    span + span {
      font-size: 18px;
    }
  }
}
</style>
